import DataMatrix from './DataMatrix'
export default DataMatrix